export default {
  suspendAgreement:{},
  setResponseCloseLink:{},
  };